
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/api/fab",
      function () {
        return require("private-next-pages/material-ui/api/fab.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/api/fab"])
      });
    }
  